import { render, staticRenderFns } from "./userTixianList.vue?vue&type=template&id=130a3afd&scoped=true"
import script from "./userTixianList.vue?vue&type=script&lang=js"
export * from "./userTixianList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a3afd",
  null
  
)

export default component.exports